import { useEffect, useRef } from 'react';

import { eventNames } from '../../../../utils/GTM/eventNames';
import { useTrackMixpanelEvent } from '../../../../utils/GTM/useTrackMixpanelEvent';

const SCROLL_DEPTH_MILESTONES = [25, 50, 75, 100] as const;

export const useTrackScrollDepth = () => {
  const { trackMixpanelEvent, isReady } = useTrackMixpanelEvent();
  const firedMilestones = useRef(new Set<(typeof SCROLL_DEPTH_MILESTONES)[number]>());

  useEffect(() => {
    if (!isReady) {
      return;
    }

    const onScroll = () => {
      const scrollableHeight = document.documentElement.scrollHeight - window.innerHeight;

      if (scrollableHeight <= 0) {
        return;
      }

      const depthPercent = (window.scrollY / scrollableHeight) * 100;

      SCROLL_DEPTH_MILESTONES.forEach((milestone) => {
        if (depthPercent >= milestone && !firedMilestones.current.has(milestone)) {
          firedMilestones.current.add(milestone);
          trackMixpanelEvent(eventNames.SCROLL_MOCK_INTERVIEW, { depth_percent: milestone });
        }
      });
    };

    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });

    return () => {
      window.removeEventListener('scroll', onScroll);
    };
  }, [isReady, trackMixpanelEvent]);
};
